import { Component, Input } from '@angular/core';
import { Contato } from '../../models/contato';
import { NavController } from 'ionic-angular';
import { ConversaContatoPage } from '../../pages/conversa-contato/conversa-contato';
import { AtalhoConversa } from '../shared/abstract/atalho-conversa';
import { FotoProvider } from '../../providers/foto/foto'

@Component({
  selector: 'conversa-usuario',
  templateUrl: 'conversa-usuario.html'
})
export class ConversaUsuarioComponent extends AtalhoConversa {

  @Input() contato: Contato;

  constructor(private navCtrl: NavController, private fotoProvider: FotoProvider) {
    super();
  }

  ngOnInit() {
    this.atualizarUltimaMensagem(this.contato.mensagens);
  }

  protected atualizarNumMensagensNaoLidas(): void {
    if (this.contato.mensagens) {
      this.quantidadeMensagensNaoLidas = this.contato.mensagens.filter(m => 
        m.idUsuarioOrigem == this.contato.idUsuario && !m.statusMensagemLida).length;
    }
  }

  public abrirConversa(): void {
    /*this.navCtrl.push(ConversaContatoPage, {
      contato: this.contato
    });*/
  }

  public getFotoPerfil(): string {
    if (this.contato.hashFoto === "") {
      return "assets/img/usuario.png";
    }
    return this.fotoProvider.getUrlImagemServidor(this.contato.hashFoto);
  }

}



// WEBPACK FOOTER //
// ./src/components/conversa-usuario/conversa-usuario.ts